import { render } from "./RegisterTypeOfProducts.vue?vue&type=template&id=77fbf322"
import script from "./RegisterTypeOfProducts.vue?vue&type=script&lang=js"
export * from "./RegisterTypeOfProducts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__